//assets
import DisclaimerIcon from "../../assets/images/DisclaimerWarning.svg";
//css
import "./Footer.css";


const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-title">
        <DisclaimerIcon />
        Disclaimer
      </div>
      <div className="footer-content">
        본 시스템의 결과는 본 결과는 AI 알고리즘에 의한 1차 스크리닝 참고용이며,
        의학적 확진을 의미하지 않습니다.<br /> 최종 진단은 반드시 전문의의 임상적
        판단과 추가 정밀 검사 결과를 종합하여 내려져야 합니다.
      </div>
    </div>
  );
};

export default Footer;
